import React from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import useOutsetaAuth from '../hooks/useOutsetaAuth';
import { MEMBERS_PATH } from '../membersPath';
import { MEMBER_SECTIONS, getSection } from '../utils/membersApi';
import MembersSection from '../components/members/MembersSection';
import MemberDirectory from '../components/members/MemberDirectory';
import './MembersHome.css';

const SECTION_ICONS = {
  board: '📑',
  conferences: '🎤',
  summercamps: '☀️',
  meetlearn: '🎥',
  directory: '👥',
};

const MembersHome = () => {
  const { section: sectionId } = useParams();
  const { user, openProfile } = useOutsetaAuth();
  const firstName = user && (user.given_name || user.email);
  const section = sectionId ? getSection(sectionId) : null;

  return (
    <div className="members-page">
      <div className="container">
        <h1 className="page-title">Members area</h1>
        <p className="page-subtitle">
          {firstName ? `Welcome, ${firstName}.` : 'Welcome.'} This area is reserved for EBTA members.
        </p>

        <nav className="members-tabs" aria-label="Members area sections">
          <NavLink end to={MEMBERS_PATH} className="members-tab">Overview</NavLink>
          {MEMBER_SECTIONS.map((s) => (
            <NavLink key={s.id} to={`${MEMBERS_PATH}/${s.id}`} className="members-tab">{s.short}</NavLink>
          ))}
        </nav>

        {!sectionId && (
          <>
            <div className="members-overview">
              {MEMBER_SECTIONS.map((s) => (
                <Link key={s.id} to={`${MEMBERS_PATH}/${s.id}`} className="members-overview-card">
                  <span className="members-overview-icon" aria-hidden="true">{SECTION_ICONS[s.id]}</span>
                  <h2>{s.short}</h2>
                  <p>{s.description}</p>
                </Link>
              ))}
            </div>
            <div className="members-account">
              <p>Want to update your details, membership or invoices?</p>
              <button type="button" className="members-profile-btn" onClick={openProfile}>
                Manage my membership
              </button>
            </div>
          </>
        )}

        {sectionId && !section && (
          <p className="members-status">Section not found. Please choose one of the sections above.</p>
        )}

        {section && (
          <div className="members-section">
            <h2 className="members-section-title">{section.title}</h2>
            <p className="members-section-description">{section.description}</p>
            {section.id === 'directory'
              ? <MemberDirectory onEditProfile={openProfile} />
              : <MembersSection sectionId={section.id} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default MembersHome;
